// src/components/Badge.tsx

import { type ComponentPropsWithoutRef, forwardRef } from "react"

type BadgeProps = ComponentPropsWithoutRef<"span">

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ children, ...props }: BadgeProps, forwardedRef) => {
    return (
      <span
        ref={forwardedRef}
        className="z-10 block w-fit rounded-lg border border-indigo-200/20 bg-indigo-100/60 px-3 py-2 font-semibold uppercase leading-4 tracking-tighter sm:text-sm dark:border-indigo-800/30 dark:bg-indigo-900/20"
        {...props}>
        <span className="bg-gradient-to-b from-indigo-500 to-indigo-600 bg-clip-text text-transparent dark:from-indigo-200 dark:to-indigo-400">
          {children}
        </span>
      </span>
    )
  }
)

Badge.displayName = "Badge"

export { Badge, type BadgeProps }
